module.exports = __webpack_public_path__ + "static/media/kredyt_agrobox.397f8aa7.png";